import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MatPaginator, MatSort, MatTableDataSource} from '@angular/material';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ConfigurarPastaServiceService} from '../../../configurar-pasta-service.service';
import {MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition} from '@angular/material/snack-bar';
import {TipoConteudoModel} from '../../../model/caixa/tipoconteudo.model';
import {ConteudoService} from '../../../service/caixa/conteudo.service';
import {CaixaService} from '../../../service/caixa/caixa.service';
import {ConteudoModel} from '../../../model/caixa/conteudo.model';
import {CaixaModel} from '../../../model/caixa/caixa.model';
import {SolicitacaoService} from '../../../service/solicitacao/solicitacao.service';
import {IndicarConteudoDTO} from '../../../model/solicitacao/indicarCaixa.model';
@Component({
  selector: 'app-indicar-conteudo-dialog',
  templateUrl: './indicar-conteudo-dialog.component.html',
  styleUrls: ['./indicar-conteudo-dialog.component.scss']
})
export class IndicarConteudoDialogComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  public caixas: any[] = this.data.caixas;
  public areaId: number = this.data.areaId;
  public clienteId: number = this.data.clienteId;
  public solicitacaoId: number = this.data.solicitacaoId;
  public tpSolicitacao: string = this.data.tpSolicitacao;
  public conteudos: any[] = [];
  public indicarConteudoDto: IndicarConteudoDTO;
  tiposDocumentais: any[];
  showSaveConteudo = false;
  loading = false;
  selectRecipienteBool = false;
  submit = false;
  idCaixaSelected: number;
  disabledButton = true;
  caixa: CaixaModel;
  displayedColumns = ['#', 'cod', 'tipoConteudo', 'descricaoConteudo'];
  conteudoDataSource = new MatTableDataSource<any[]>([]);
  conteudoForm: FormGroup;
  horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  public tipoConteudos: TipoConteudoModel[];
  conteudoCustodia: any[] = [];
  conteudoConsulta: any[] = [];
  constructor(
    private _snackBar: MatSnackBar,
    private service: ConfigurarPastaServiceService,
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<IndicarConteudoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private conteudoService: ConteudoService,
    private caixaService: CaixaService,
    private solicitacaoService: SolicitacaoService,
  ) { }

  ngOnInit() {
    this.getNodeClienteArea(this.clienteId, this.areaId);
    // console.log(this.data);
  }

  buscarConteudoCustodia(caixaId: number) {
    this.loading = true;
    this.conteudoService.buscarConteudoEmCustodia(caixaId).subscribe(data => {
      if (data.success) {
        this.conteudoCustodia = data.result;
        this.conteudoDataSource.data = data.result;
        this.conteudoDataSource.paginator = this.paginator;
        this.conteudoDataSource.sort = this.sort;
        this.selectRecipienteBool = true;
      } else {
        this.openSnackBarError(data.message);
      }
      this.loading = false;
    }, err => {
      console.error(err);
      this.loading = false;
    });
  }

  buscarConteudoConsulta(caixaId: number) {
    this.loading = true;
    this.conteudoService.buscarConteudoEmConsulta(caixaId).subscribe(data => {
      if (data.success) {
        this.conteudoConsulta = data.result;
        this.conteudoDataSource.data = data.result;
        this.conteudoDataSource.paginator = this.paginator;
        this.conteudoDataSource.sort = this.sort;
        this.selectRecipienteBool = true;
      } else {
        this.openSnackBarError(data.message);
      }
      this.loading = false;
    }, err => {
      console.error(err);
      this.loading = false;
    });
  }

  getNodeClienteArea(clienteId, areaId) {
    this.service.getNodeClienteArea(clienteId, areaId).subscribe(data => {
      // // console.log(data);
      if (data.length === 0) {
        this.openSnackBarError('Nenhum Tipo Documental associado !');
        this.tiposDocumentais = null;
        this.loading = false;
      } else {
        this.tiposDocumentais = data;
        // // console.log(this.tiposDocumentais);
        this.tipoConteudos = this.tiposDocumentais;
        this.loading = false;
      }
    }, err => {
      console.error(err);
      this.loading = false;
    });
  }
  selectRecipiente(event: any) {
    this.idCaixaSelected = event.value;
    this.disabledButton = false;
    if (this.tpSolicitacao==='DEVOLUCAO_CONTEUDO') {
      this.buscarConteudoConsulta(this.idCaixaSelected);
    } else {
      this.buscarConteudoCustodia(this.idCaixaSelected);
    }
  }

  checkAllCaixa(event: any) {
    if (event) {
      for (
        let i = 0;
        i < this.conteudoDataSource.data.length;
        i++
      ) {
        this.conteudoDataSource.data[i]["isSelectedCaixa"] = true;
        if (this.indicarConteudoDto!=undefined) {
          let response = this.inserirCaixa(this.idCaixaSelected, this.conteudoDataSource.data[i]['id']);
          // console.log(response);
        } else {
          let response = this.createInidicarConteudo(this.idCaixaSelected, this.conteudoDataSource.data[i]['id']);
          // console.log(response);
        }
        //this.idCaixas.push(this.dataSource.data[i]["id"]);
        //this.buttonRelatorio = false;
      }
    } else {
      for (
        let i = 0;
        i < this.conteudoDataSource.data.length;
        i++
      ) {
        this.conteudoDataSource.data[i]["isSelectedCaixa"] = false;
        var id = this.conteudoDataSource.data[i]["id"];
        if (this.indicarConteudoDto!=undefined) {
          let response = this.removerCaixa(this.idCaixaSelected, id);
          // console.log(response);
        }
      }
    }
  }

  salvarNovoConteudo() {
    this.showSaveConteudo = true;
    this.criarFormConteudo();
  }

  getCaixa(idCaixa: Number) {
    this.caixaService.getCaixaUnica(idCaixa).subscribe(data => {
      this.conteudoForm.get('caixa').setValue(data);
      this.caixa = data;
    }, err => {
      console.error(err);
    });
  }

  adicionarItem() {
    this.loading = true;
    const conteudo = this.conteudoForm.value;
    this.conteudoService.incluirItens(this.idCaixaSelected, conteudo).subscribe(data => {
      this.loading = false;
      this.openSnackBarSuccess(`Conteúdo adicionado com sucesso !`);
      this.conteudoForm.reset();
      this.submit = false;
      this.showSaveConteudo = false;
      this.adicionarItemTabela(data);
    }, err => {
      this.loading = false;
      console.error(err);
      if (err.error.message === 'Conteúdo já criado com este RG de Item !') {
        this.openSnackBarError(err.error.message);
      } else {
        this.openSnackBarError('Preencha todos os campos obrigatórios !');
      }
    });
  }

  adicionarItemTabela(data: ConteudoModel) {
    const novoElemento: any = {
      id: data.id,
      descricaoTipoConteudo: data.nodeDicionario.title,
      rgCaixa: this.caixa.rgCaixa,
      descricaoConteudo: data.descricaoConteudo,
      dataFinal: null,
      dataInicial: null,
      rgItem: null,
      numDocInicial: null,
      origem: null,
      numDocFinal: null
    };
    this.conteudoDataSource.data = [novoElemento, ...this.conteudoDataSource.data];
    this.caixas.forEach(recip => {
      if (recip.id === this.idCaixaSelected) {
        recip.conteudosList.unshift(novoElemento);
      }
    });
  }

  criarFormConteudo() {
    this.conteudoForm = this.fb.group({
      rgItem: [''],
      descricaoConteudo: ['', Validators.required],
      origem: [''],
      dataInicial: [''],
      dataFinal: [''],
      numeroDocumentos: [''],
      tipoConteudo: [null],
      nodeDicionario: [null, Validators.required],
      caixa: [null],
      numDocInicial: [''],
      numDocFinal: ['']
    });

    this.getCaixa(this.idCaixaSelected);
  }

  checkIndividualCaixa(event: any, id: number) {
    // console.log(event);
    // console.log(id);
    // console.log(this.indicarConteudoDto);
    if (event) {
      if (this.indicarConteudoDto !== undefined) {
        let controle = false;
        this.indicarConteudoDto.caixas.forEach(el => {
          if (el.caixaId === this.idCaixaSelected) {
            controle = true;
            if (!el.conteudosIds.includes(id)) {
              el.conteudosIds.push(id);
            }
          }
        });
        if (!controle) {
          const retorno = this.inserirCaixa(this.idCaixaSelected, id);
          // console.log(retorno);
        }
      } else {
        const retorno = this.createInidicarConteudo(this.idCaixaSelected, id);
        // console.log(retorno);
      }
    } else {
      this.indicarConteudoDto.caixas.forEach(el => {
        if (el.caixaId === this.idCaixaSelected) {
          let index = el.conteudosIds.indexOf(id);
          el.conteudosIds.splice(index, 1);
        }
      });

      const retorno = this.removerCaixa(this.idCaixaSelected, id);
      // console.log(retorno);
    }
    // const caixaDTO: CaixaDTO = {
    //   caixaId: this.idCaixaSelected,
    //   conteudosIds: [id]
    // }
  }

  createInidicarConteudo(idCaixa: number, idConteudo: number): IndicarConteudoDTO {
    this.indicarConteudoDto = {
      solicitacaoId: null,
      caixas: [{
        caixaId: idCaixa,
        conteudosIds: [idConteudo],
      }]
    };
    return this.indicarConteudoDto;
  }
  inserirCaixa(idCaixa: number, idConteudo: number): IndicarConteudoDTO {
    let controle = false;
    this.indicarConteudoDto.caixas.forEach(el => {
      if (el.caixaId === idCaixa) {
        controle = true;
        el.conteudosIds.push(idConteudo);
      }
    });

    if (!controle) {
      this.indicarConteudoDto.caixas.push({
        caixaId: idCaixa,
        conteudosIds: [idConteudo]
      });
    }

    return this.indicarConteudoDto;
  }

  removerCaixa(idCaixa: number, idConteudo: number): IndicarConteudoDTO {
    this.indicarConteudoDto.caixas.forEach(element => {
      if (element.caixaId === idCaixa) {
        element.conteudosIds.splice(element.conteudosIds.indexOf(idConteudo), 1);
      }

      if (element.conteudosIds.length <= 0) {
        let indexRemove = this.indicarConteudoDto.caixas.indexOf(element);
        this.indicarConteudoDto.caixas.splice(indexRemove, 1);
      }
    });
    return this.indicarConteudoDto;
  }

  salvarConteudosRequisicao() {
    this.indicarConteudoDto.solicitacaoId = this.solicitacaoId;
    this.requisitarDocumento(this.indicarConteudoDto);
  }

  requisitarDocumento(objetoBody: IndicarConteudoDTO) {
    this.solicitacaoService.requisitarConteudo(objetoBody).subscribe(data => {
      // console.log(data);
      if (data.success) {
        this.openSnackBarSuccess('Conteúdos foram selecionados com sucesso!');
        this.dialogRef.close(data);
      } else {
        this.openSnackBarError(data.message);
      }
    }, err => {
      console.error(err);
    });
  }

  openSnackBarSuccess(message: string) {
    this._snackBar.open(message, '', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 4000,
      panelClass: ['success-snackbar']
    });
  }

  openSnackBarError(message: string) {
    this._snackBar.open(message, '', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 3000,
      panelClass: ['error-snackbar']
    });
  }

}



// WEBPACK FOOTER //
// /app/src/app/components/solicitacao/indicar-conteudo-dialog/indicar-conteudo-dialog.component.ts